import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  date: string().required('Field is required'),
  reason: string().trim().max(2000, 'Max length - 2000 symbols').required('Field is required'),
});

export default yupResolver(validationSchema);
